export const SENDER_FIRST = 'sender-first';
export const SENDER_LAST = 'sender-last';
export const SENDER_NEVER = 'sender-never';

export default {
  SENDER_FIRST,
  SENDER_LAST,
  SENDER_NEVER,
};



// WEBPACK FOOTER //
// ./src-react/SendForSignatureToolbar/SendForSignatureShareConstants.jsx